import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import {
  APP_LANGUAGE_STORAGE_KEY,
  LANDING_LANGUAGE_COOKIE,
  normalizeAppLocale,
  persistAppLanguage,
} from "@/shared/lib/appLocale";

function readCookie(name: string): string | null {
  if (typeof document === "undefined") {
    return null;
  }

  const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const matches = [
    ...document.cookie.matchAll(new RegExp(`(?:^|;\\s*)${escapedName}=([^;]+)`, "g")),
  ];
  const value = matches.at(-1)?.[1];
  return value ? decodeURIComponent(value) : null;
}

function detectInitialLanguage(): string {
  if (typeof window === "undefined") {
    return "en";
  }

  const cookieLang = readCookie(LANDING_LANGUAGE_COOKIE);
  if (cookieLang) {
    return normalizeAppLocale(cookieLang);
  }

  const savedLang = window.localStorage.getItem(APP_LANGUAGE_STORAGE_KEY);
  if (savedLang) {
    return normalizeAppLocale(savedLang);
  }

  const browserLang = window.navigator.languages?.[0] ?? window.navigator.language;
  return normalizeAppLocale(browserLang);
}

const initialLanguage = persistAppLanguage(detectInitialLanguage());

i18n
  .use(Backend) // Подгружает файлы из /public/locales
  .use(initReactI18next) // Интеграция с React
  .init({
    fallbackLng: "en", // Язык по умолчанию
    lng: initialLanguage,
    ns: [
      "spreadSelection",
      "cardsSelection",
      "analysis",
      "spreads",
      "userProfile",
      "layout",
      "billing",
      "pricing",
      "payment",
      "news",
      "adminPartners",
      "partnerDashboard",
      "readingDraft",
    ], // Список твоих файлов
    defaultNS: "spreadSelection",
    debug: false, // Включи true для отладки в консоли

    interpolation: {
      escapeValue: false, // React уже защищает от XSS
    },

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
